(function () {
  'use strict';

  var activate = function (buttons, panels, button, keyName, panelName) {
    buttons.forEach(function (item) {
      item.setAttribute('aria-selected', String(item === button));
    });
    panels.forEach(function (panel) {
      panel.hidden = panel.dataset[panelName] !== button.dataset[keyName];
    });
  };

  var initAbout = function (root) {
    var tabs = Array.from(root.querySelectorAll('[data-about-audience]'));
    var panels = Array.from(root.querySelectorAll('[data-about-panel]'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tabs, panels, tab, 'aboutAudience', 'aboutPanel');
      });
    });

    var quotes = Array.from(root.querySelectorAll('[data-about-quote]'));
    var index = 0;
    var showQuote = function (next) {
      if (!quotes.length) return;
      index = (next + quotes.length) % quotes.length;
      quotes.forEach(function (quote, quoteIndex) { quote.hidden = quoteIndex !== index; });
      var status = root.querySelector('[data-quote-status]');
      if (status) status.textContent = (index + 1) + ' of ' + quotes.length;
    };
    var previous = root.querySelector('[data-quote-previous]');
    var next = root.querySelector('[data-quote-next]');
    if (previous) previous.addEventListener('click', function () { showQuote(index - 1); });
    if (next) next.addEventListener('click', function () { showQuote(index + 1); });
    showQuote(0);
  };

  var initContact = function (root) {
    var routes = Array.from(root.querySelectorAll('[data-contact-route]'));
    var panels = Array.from(root.querySelectorAll('[data-contact-panel]'));
    routes.forEach(function (route) {
      route.addEventListener('click', function () {
        activate(routes, panels, route, 'contactRoute', 'contactPanel');
        var enquiry = root.querySelector('[data-contact-enquiry]');
        if (enquiry && Array.from(enquiry.options).some(function (option) { return option.value === route.dataset.contactRoute; })) enquiry.value = route.dataset.contactRoute;
      });
    });

    var enquiry = root.querySelector('[data-contact-enquiry]');
    if (enquiry) enquiry.addEventListener('change', function () {
      var route = routes.find(function (item) { return item.dataset.contactRoute === enquiry.value; });
      if (route) activate(routes, panels, route, 'contactRoute', 'contactPanel');
    });

    var copy = root.querySelector('[data-copy-address]');
    var status = root.querySelector('[data-copy-status]');
    if (copy) copy.addEventListener('click', function () {
      var address = copy.dataset.copyAddress;
      var done = function () { if (status) status.textContent = 'Address copied.'; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(address).then(done).catch(function () { if (status) status.textContent = address; });
      } else if (status) {
        status.textContent = address;
      }
    });
  };

  var init = function (scope) {
    (scope || document).querySelectorAll('[data-fcp-about]').forEach(initAbout);
    (scope || document).querySelectorAll('[data-fcp-contact]').forEach(initContact);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
